import React from 'react';
import styled from 'styled-components';
import Navbar from "../components/Navbar";
import Announcement from "../components/Announcement";
import Footer from "../components/Footer";
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import {mobile} from "../responsive";
import { useState , useEffect} from "react";
import {useSelector} from "react-redux";
import StripeCheckout from 'react-stripe-checkout';
import axios from 'axios';
import {userRequest} from "../requestMethod";
import { useNavigate } from 'react-router-dom';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
    Link
} from 'react-router-dom';
import { addProduct ,removeProduct} from '../redux/cartRedux';


const KEY = "pk_test_51MbcVmSEttIpGXiXly6MhpOmjVkrlEKI8RUS78Trfn7RGPzryVuLMRXL7FORZLMe7jyDTJhby7bzf5BRSvN8rluL00VcTDpuJG";
console.log(KEY);


const Container=styled.div`

`;



const Wrapper=styled.div`
padding:20px;

${mobile({})}

`;


const Title=styled.h1`
font-weight:300;
text-align:center;

`;

const Top=styled.div`
display:flex;
align-items:center;
justify-content:space-between;
padding:20px;

`;

const TopButton=styled.button`
padding:10px;
font-weight:600;
cursor:pointer;
border:${props=>props.type==="filled" && "none"};
background-color:${(props)=>props.type==="filled" ? "black" : "transparent"};
color:${props=>props.type==="filled" && "white"};
`;

const TopTexts=styled.div`
${mobile({display:"none"})}

`;

const TopText=styled.span`
text-decoration:underline;
cursor:pointer;
margin:0px 10px;

`;



const Bottom=styled.div`
display:flex;
justify-content:space-between;

${mobile({flexDirection:"column"})}

`;

const Info=styled.div`
flex:3
`;



const Product=styled.div`
display:flex;
justify-content:space-between;

${mobile({flexDirection:"column"})}
`;

const ProductDetail=styled.div`
flex:2;
display:flex;

`;


const Image=styled.img`
width:250px;
margin:5px;

${mobile({width:"200px"})}

`;

const Details=styled.div`
padding:20px;
display:flex;
flex-direction:column;
justify-content:space-around;


`;

const ProductName=styled.span`

`;

const ProductId=styled.span`


`;

const ProductColor=styled.div`
width:20px;
height:20px;
border-radius:50%;
background-color:${props=>props.color};

`;

const ProductSize=styled.span`

`;

const PriceDetail=styled.div`
flex:1;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
`;

const ProductAmountContainer=styled.div`
display:flex;
align-items:center;
margin-bottom:20px;
`;

const ProductAmount=styled.div`
font-size:24px;
margin:5px;

${mobile({margin:"5px 15px"})}
`;

const ProductPrice=styled.div`
font-size:30px;
font-weight:200;

${mobile({marginBottom:"20px"})}
`;
const Hr=styled.hr`
background-color:#eee;
border:none;
height:1px;
`;


const Summary=styled.div`
flex:1;
border:0.5px solid lightgray;
border-radius:10px;
padding:20px;
height:55vh;
`;

const SummaryTitle=styled.h1`
font-weight:200;

`;

const SummaryItem=styled.div`
margin:30px 0px;
display:flex;
justify-content:space-between;
font-weight:${props=>props.type==="total" && "500"};
font-size:${props=>props.type==="total" && "20px"};

`;

const SummaryItemText=styled.span`

`;

const SummaryItemPrice=styled.span`

`;

const Button=styled.button`
width:100%;
padding:10px;
background-color:black;
color:white;
font-weight:600;
cursor:pointer;

`;





 function Cart() {

   const cart =useSelector((state)=>state.cart);

   const [stripeToken,setStripeToken] =useState(null);
   const navigate = useNavigate();

 const onToken =(token)=>{
   setStripeToken(token);
 };

 useEffect(()=>{
   const makeRequest= async ()=>{
     try{

       const res = await userRequest.post("/checkout/payment",{

          tokenId:stripeToken.id,
          amount:cart.total*100,

       });
        navigate.push("/success", {
          stripeData: res.data,
          products: cart, });

     }catch(err){
       console.log(err);
     }
   };
    stripeToken && cart.total>=1 && makeRequest();
 },[stripeToken,cart.total]);



  return (
     <Container>
        <Announcement/>
        <Navbar/>
        <Wrapper>
           <Title>YOUR BAG</Title>
           <Top>
            <Link to ="/products">
             <TopButton>CONTINUE SHOPPING</TopButton>
             </Link>
             <TopTexts>
                <TopText>Shopping Bag({cart.quantity})</TopText>
                <TopText>Your Wishlist(0)</TopText>
             </TopTexts>
             <StripeCheckout
                 name="Lama Shop"
                 image="https://yt3.googleusercontent.com/ytc/AL5GRJUOhe9c1D67-yLQEkT2EqyRclI5V3EOTANZQXmt=s900-c-k-c0x00ffffff-no-rj"
                 shippingAddress
                 billingAddress
                 description={`Your total is ${cart.total}`}
                 amount={cart.total*100}
                 token={onToken}
                 stripeKey={KEY}
             >
             <TopButton type="filled">CHECKOUT NOW</TopButton>
              </StripeCheckout>
           </Top>

           <Bottom>
             <Info>
                {cart.products.map((product)=>
                  (<Product>
                    <ProductDetail>
                         <Image src={product.img}/>
                         <Details>
                            <ProductName><b>Product:</b> {product.title}</ProductName>
                            <ProductId><b>ID:</b> {product._id}</ProductId>
                            <ProductColor color={product.color}/>
                            <ProductSize><b>Size:</b> {product.size}</ProductSize>
                         </Details>
                    </ProductDetail>
                    <PriceDetail>
                        <ProductAmountContainer>
                           <AddIcon/>
                           <ProductAmount>{product.quantity}</ProductAmount>
                           <RemoveIcon/>
                        </ProductAmountContainer>
                        <ProductPrice>{product.price*product.quantity}</ProductPrice>
                    </PriceDetail>
                </Product>

                   )
              )}
                   <Hr/>



                </Info>
                <Summary>
                     <SummaryTitle>ORDER SUMMARY</SummaryTitle>
                     <SummaryItem>
                          <SummaryItemText>Subtotal</SummaryItemText>
                          <SummaryItemPrice>{cart.total}</SummaryItemPrice>
                     </SummaryItem>
                     <SummaryItem>
                          <SummaryItemText>Estimated Shipping</SummaryItemText>
                          <SummaryItemPrice>Rs 400 </SummaryItemPrice>
                     </SummaryItem>
                     <SummaryItem>
                          <SummaryItemText>Shipping Discount</SummaryItemText>
                          <SummaryItemPrice>Rs -100 </SummaryItemPrice>
                     </SummaryItem>
                     <SummaryItem type ="total">
                          <SummaryItemText >Total</SummaryItemText>
                          <SummaryItemPrice>{cart.total+300}</SummaryItemPrice>
                     </SummaryItem>
                     <StripeCheckout
                         name="Lama Shop"
                         image="https://yt3.googleusercontent.com/ytc/AL5GRJUOhe9c1D67-yLQEkT2EqyRclI5V3EOTANZQXmt=s900-c-k-c0x00ffffff-no-rj"
                         shippingAddress
                         billingAddress
                         description={`Your total is ${cart.total}`}
                         amount={cart.total*100}
                         token={onToken}
                         stripeKey={KEY}
                     >
                     <Button>CHECKOUT NOW</Button>
                     </StripeCheckout>
                </Summary>

           </Bottom>

        </Wrapper>
        <Footer/>
     </Container>
  );
};

export default Cart;
